import React, { useState, useRef, useEffect } from "react";

import IdleTimer from "react-idle-timer";
import { useDispatch } from "react-redux";
import { fv, Button, Modal } from "react-bootstrap";
import { UNAUTHRIZEDPAGE } from "../../constants";
import { SIGNOUTPAGE } from "../../constants";
// Bootstrap
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import * as Constants from "../../constants";
// action
import { refershToken } from "../../redux/actions/refreshToken";

const SessionTimeOut = (props) => {
  //const [loggedIn, setLoggedIn] = useState(true)
  const [showModal, setShowModal] = useState(false);
  const [isRefreshTokenNeeded, setIsRefreshTokenNeeded] = useState(false);
  const idleTimerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!isRefreshTokenNeeded) {
      const intervalId = setInterval(function () {
        dispatch(refershToken());
      }, Constants.LOGOUT_WARN_TIME);
      return () => clearInterval(intervalId);
    }
  }, [isRefreshTokenNeeded]);

  const redirectToSignout = () => {
    //window.open(UNAUTHRIZEDPAGE, "_self", "norefferer"); //redirect to signout page on session timeout
    history.push("/signout");
    // window.location.href = SIGNOUTPAGE;
    // window.open(SIGNOUTPAGE, "_self"); //redirect to signout page on session timeout
    // window.location.assign(SIGNOUTPAGE);
    // const myWindow = window.open(SIGNOUTPAGE, "_self", "norefferer"); //redirect to signout page on session timeout
    // myWindow.location.reload();
  };

  const onIdle = (e) => {
    setShowModal(true);
    setIsRefreshTokenNeeded(true);
    sessionTimeoutRef.current = setTimeout(logOut, Constants.LOGOUT_AUTO_TIME);
  };

  const logOut = async () => {
    setShowModal(false);
    clearTimeout(sessionTimeoutRef.current);
    redirectToSignout();
  };

  const stayConnected = () => {
    setShowModal(false);
    clearTimeout(sessionTimeoutRef.current);
    dispatch(refershToken());
  };

  return (
    <div>
      <IdleTimer
        ref={idleTimerRef}
        timeout={Constants.LOGOUT_WARN_TIME}
        onIdle={onIdle}
        // debounce={}
        element={document}
      />
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        backdrop="static"
      >
        <Modal.Title className="pl-3 pt-3 font-weight-bold">
          Your Session is About to Expire!
        </Modal.Title>
        <Modal.Body>
          <div style={{ color: "gray" }}>
            You are about to be logged out due to inactivity, do you want to
            stay logged in?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col className="text-center max-auto">
              <div className="text-center">
                <Button variant="red" onClick={logOut} className="mr-2">
                  Logout
                </Button>
                <Button variant="blue" onClick={stayConnected}>
                  Stay Connected
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SessionTimeOut;
